import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { OpenAPI as DeprecatedApi } from './openapi/requests';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import App from './App';
import { ConfigProvider, CurrentEnvironment, Environment } from './contexts/ConfigContext';

import ReactGA from "react-ga4"
import { DialogProvider } from './contexts/DialogContext';

ReactGA.initialize("G-X3J1VP9Z8L");

export const BASE_PATH = (CurrentEnvironment === Environment.Production ? process.env.REACT_APP_APIBASEPATH_PROD : 
        (CurrentEnvironment === Environment.Experimental ? process.env.REACT_APP_APIBASEPATH_EXPERIMENTAL : process.env.REACT_APP_APIBASEPATH_DEV)) || "";

DeprecatedApi.BASE = BASE_PATH;
const queryClient = new QueryClient();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);


root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <DialogProvider>
        <BrowserRouter>
          <AuthProvider>
            <ConfigProvider>
              <App />
            </ConfigProvider>
          </AuthProvider>
        </BrowserRouter>
      </DialogProvider>
    </QueryClientProvider>
  </React.StrictMode>
);
